export default __webpack_public_path__ + "static/media/ShakoCho.636fedeb.webp";